import controller from './mf.controller';
import template from './mf.html';

export default {
	template,
	bindings: {
		appendToBody:        '@?',
		focus:               '@?',
		key:                 '@?', // for use in formio
		ktable:              '<?',
		lastForm:            '<?', // should be moved in options
		mfCard:              '<?',
		mfClass:             '@?',
		mfCustom:            '@?', // should be moved in options
		mfLinker:            '@?',
		mfList:              '<?',
		mfUploadFile:        '<?', // may be removed in future release
		mfValidate:          '<?',
		mode:                '@?', // should be moved in options
		ngDisabled:          '<?',
		noDirtyCheck:        '@?', // should be moved in options
		onBlur:              '&?',
		onCreate:            '&?',
		onDelete:            '&?',
		onFocus:             '&?',
		onSelect:            '&?',
		options:             '<?',
		order:               '@?',
		placeholder:         '@?',
		suggest:             '@?',
		title:               '@?',
		values:              '=?ngModel',
	},
	controller,
	// controllerAs: 'ctrl',
	require:  {
		ngModelCtrl: '?ngModel',
		kform: '^^?kform',
	},
};
